<div class="add-info">
  <p class="block-label">Conversation History</p>
  <div class="request-text" #scrollContainer>
    @for (message of messagesStream; track message) {
      <div class="message" [ngClass]="{ 'my-message': !message.isAdmin }">
        <div class="heading">
          <span>{{ message.userFullname }}</span>
          at {{ message.createdDate | date: 'y-MM-dd hh:mm a' }}
        </div>
        <span class="text">{{ message.text }}</span>
        @if (message.hasOwnProperty('documentId') || message.hasOwnProperty('cloudDocumentUri')) {
          <div class="doc-icon">
            <span class="icon" (click)="openDocument(message)"><ods-icon variant="chat"></ods-icon></span>
          </div>
        }
      </div>
    }
  </div>

  <div class="divider"></div>

  <p class="block-label">Attach Documentation</p>
  <div class="upload-block">
    <div class="flex">
      <div class="action-btn-lg primary upload">
        <span class="text">
          upload document
          @if (uploadProgres) {
            <span>{{ uploadProgres }} %</span>
          }
        </span>
        <span class="icon"><ods-icon variant="upload" aria-hidden="true"></ods-icon></span>
        <input (change)="uploadFile($event)" #uploadBtn type="file" class="upload-hidden" />
        <span class="explanatory">Document must be in a JPG, JPEG, PNG, or PDF format and cannot exceed 10MB.</span>
        @if (isError) {
          <div class="error">
            <h3>File type or size is wrong.</h3>
          </div>
        }
      </div>
      @if (documentAttached) {
        <div class="fileName">
          Document is successfully attached.
          <ods-link routerLink="/home" variant="inline">Return to home page</ods-link>
        </div>
      }
    </div>
  </div>

  <div class="divider"></div>
  <p class="block-label">Send Message to Employee Health Team (optional)</p>

  <ods-text-area
    [value]="requestedInfo"
    (change)="onChangeRequestedInfo($event)"
    count=""
    cols="20"
    maxlength="500"
    minlength="0"
    placeholder="Enter Additional Info"
    rows="4"
    autofocus
    wrap="soft"
    required></ods-text-area>
  @if (requestedInfo === '' || requestedInfo?.trim() === '') {
    <div class="error">Please, enter additional info</div>
  }
  <div class="btn-container">
    <div class="submit-btn-box">
      <ods-button variant="primary" (click)="sendAdditionalInfo()">SEND</ods-button>
    </div>
  </div>
</div>
